import localforage from "localforage";
import { setup } from "axios-cache-adapter";

let tmp = location.href

if (tmp.startsWith("http://")) {
    var jsport = tmp.replace("http://", "").split("/")[0].split(":")[1]
    tmp = tmp.replace(jsport, '5500')
}

let initialLocation = tmp.split('/')

const SERVER_URL = initialLocation[0] + '//' + initialLocation[2] + '/api/'

const forageStore = localforage.createInstance({
    driver: [localforage.INDEXEDDB, localforage.LOCALSTORAGE],
    name: "nv-cache",
});

export const defaultApi = setup({
    baseURL: SERVER_URL,
    cache: {
        maxAge: 0
    }
});

export const api = setup({
    baseURL: SERVER_URL,
    withCredentials: true,
    cache: {
        maxAge: 0
    }
});

export const apiWithCache = setup({
    baseURL: SERVER_URL,
    withCredentials: true,
    cache: {
        maxAge: 7 * 24 * 60 * 60 * 1000,
        store: forageStore,
        exclude: {
            paths: [],
            query: false,
            filter: null,
        },
        invalidate: async (config, request) => {
            if (request.clearCacheEntry) {
                await config.store.removeItem(config.uuid);
            }
        },
        readHeaders: false,
    },
});

export const ADMIN_EMAILS = 'chandra.poojari@ericsson.com;anusha.mallireddy@ericsson.com;kumar.ray@ericsson.com'
